<template>
  <div class="bbp-radio-form">
    <label class="bbp-radio-form-item" v-for="option in options" :key="option.id">
      <input class="bbp-radio-form-item__input" type="radio" :value="option.id" v-model="picked">
      <span class="bbp-radio-form-item__checkmark"/>
      <span class="bbp-radio-form-item__title">{{option[input.listLabel]}}</span>
    </label>
  </div>
</template>

<script>
import {get, set} from 'lodash'

export default {
  name: 'BBPRadio',
  props: ['input', 'model'],
  data () {
    return {
      picked: false
    }
  },
  computed: {
    options () {
      return get(this.input, 'options', [])
    }
  },
  methods: {
    setDefaultValue () {
      const defaultVal = get(this.input, ['options', 0], {})
      const value = get(this.model, this.input.model, defaultVal)
      this.picked = value.id
    }
  },
  watch: {
    picked () {
      this.$emit('input', this.picked)
      set(this.model, this.input.model, this.picked)
    }
  },
  beforeMount () {
    this.setDefaultValue()
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../sass/variables";
  @import "../../../../sass/mixins";

  .bbp-radio-form {
    display: flex;
    align-items: center;
    user-select: none;

    &-item {
      position: relative;
      display: flex;
      align-items: center;
      margin-right: 20px;
      cursor: pointer;
      transition: 0.3s;

      &:hover {
        opacity: 0.8;
      }

      &__input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;

        &:checked + .bbp-radio-form-item__checkmark {
          &:after {
            opacity: 1;
          }
        }
      }

      &__checkmark {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 12px;
        height: 12px;
        border: 1px solid $color-accent;
        box-sizing: border-box;
        border-radius: 50%;
        margin-right: 5px;

        &:after {
          content: '';
          position: absolute;
          background-color: $color-accent;
          width: 6px;
          height: 6px;
          opacity: 0;
          border-radius: 50%;
          transition: 0.3s;
        }
      }

      &__title {
        font-weight: 400;
        font-size: 14px;
        line-height: 16px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/BBPForm/BBPRadio/BBPRadio.vue